<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16i6QdB/images/cover.jpg?1685327426085" alt="This image is the cover for the book A Solstice Journey"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Solstice Journey
      </h1>
      <p class="bookDescription body article font2">
        <p>Upon leaving his company's Christmas party, Gunnar Dagviðurson decides to walk to the train and enjoy the snowfall, only to get caught in a winter storm that magically transports him to a mysterious foreign realm. That’s how Celyn finds him, stumbling blindly through the snow, and Celyn takes Gunnar home to a castle of faery. Gunnar wants to find his way home for Christmas, but suddenly he’s faced with a choice: does he go back to his adopted family in the human world or stay with the magical family he’s found?</p><p><i>A story from the Dreamspinner Press 2013 Advent Calendar package "Heartwarming".</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Felicitas Ivey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b0d9ba2